"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridCellRendererAdapter = void 0;
require("react");
require("../../Grid");
require("../types");
const gridCellRendererAdapter = (key, cellRenderer) => {
    return (columnProps, rowData, rowHeight, rowIndex) => {
        return cellRenderer({
            rowData,
            rowIndex,
            cellData: rowData[key],
            justify: columnProps.align,
            disabled: columnProps.isDisabled,
            columnWidth: columnProps.widthColumn || 200,
            tooltipMaxWidth: columnProps.tooltipMaxWidth,
        });
    };
};
exports.gridCellRendererAdapter = gridCellRendererAdapter;
//# sourceMappingURL=gridCellRendererAdapter.js.map